function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSetupAnalyticsAmico(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 500 500",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "freepik--Shadows--inject-217"
  }, /*#__PURE__*/React.createElement("path", {
    id: "freepik--Shadow--inject-217",
    d: "M83.39,411.5,60.31,398.17c-2.32-1.33-2.32-3.5,0-4.84L335.15,234.65a9.3,9.3,0,0,1,8.38,0L366.62,248c2.31,1.34,2.31,3.5,0,4.84L91.78,411.5A9.26,9.26,0,0,1,83.39,411.5Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "freepik--shadow--inject-217",
    cx: 420.09,
    cy: 306.92,
    rx: 41.91,
    ry: 24.2,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "freepik--shadow--inject-217",
    cx: 199.64,
    cy: 440.84,
    rx: 39.08,
    ry: 22.56,
    style: {
      fill: "#e0e0e0"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Plant--inject-217"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--Plants--inject-217"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M86.39,363.9s-1.7-14.89-9.1-26.44-17.58-18.77-27.08-19.52-17.16,8-7,14S71.42,344,79.72,366.48Z",
    style: {
      fill: "#34C38F"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.39,363.9s-1.7-14.89-9.1-26.44-17.58-18.77-27.08-19.52-17.16,8-7,14S71.42,344,79.72,366.48Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.6,360a.17.17,0,0,0,.1,0,.5.5,0,0,0,.28-.66c-10-24.67-29.09-35-37.78-37a.5.5,0,0,0-.6.38.49.49,0,0,0,.38.61c8.5,2,27.2,12.09,37.06,36.37A.51.51,0,0,0,83.6,360Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.89,360.32c.86,1.94,3,2.95,4.94,3.74s4.11,1.65,5.17,3.48c2.14,3.7-1.38,8.91.92,12.51a6.68,6.68,0,0,0,4.53,2.63,44,44,0,0,0,4.45.39,16.37,16.37,0,0,0,2.11-.16,9.63,9.63,0,0,1,6.13.65c2.94,1.65,3.84,5.37,5.63,8.23A14,14,0,0,0,76.68,398c1.32.17,3.78.41,5.13-.34a2.68,2.68,0,0,0,.28-.18l0,0c.18-.21.42-.47.52-.62a.19.19,0,0,0,.05-.09c.52-1.92-.33-3.91-.36-5.9a2,2,0,0,1,0-.35c.08-2.31.14-4.6.2-6.9q.17-6.35.12-12.7c0-2.75.31-5.76-.86-8.35-1.29-2.85-4.49-2.91-5.7-5.71-.48-1.11-.74-2.31-1.21-3.43a9.85,9.85,0,0,0-8.39-5.86c-5.59-.28-10.61,4.24-16.2,3.83a42.41,42.41,0,0,1-4.28-.81c-4.53-.85-9.76.44-12.31,4.27A5.85,5.85,0,0,0,32.89,360.32Z",
    style: {
      fill: "#34C38F"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.14,388h0a.48.48,0,0,0,.34-.59c-7.73-29-38.27-33.18-45.42-32.67a.49.49,0,0,0-.44.52.48.48,0,0,0,.51.44c7-.51,36.87,3.59,44.43,32A.47.47,0,0,0,83.14,388Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.2,373.26a.44.44,0,0,0,.25-.13,25.4,25.4,0,0,1,20.79-5.86.48.48,0,1,0,.14-.94,26.39,26.39,0,0,0-21.61,6.13.48.48,0,0,0,0,.67A.47.47,0,0,0,49.2,373.26Z",
    style: {
      fill: "#fff"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Gears--inject-217"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--gears--inject-217"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M125.08,48.74h0a.94.94,0,0,0-1,.08L122,50.22l-.46,1.26a2.42,2.42,0,0,0,.57,2.33A11.08,11.08,0,0,1,123,55a1.41,1.41,0,0,0,2,.44l4.9-3.23a1,1,0,0,1,1-.1Zm-7.54,18c-.69-4-3.22-6-6.5-5.68a10.13,10.13,0,0,1,.68,2.32c1.08,6.29-2.91,15.22-8.9,19.94a12.2,12.2,0,0,1-6.29,2.81c2,4.22,7,4.62,12.12.55C114.64,82,118.62,73,117.54,66.73Zm.1-26.9h0a1.18,1.18,0,0,0-.38-.16l-3.69-.83a2,2,0,0,0-2.1,1L108,46.44a3,3,0,0,1-.78.88h0a2.67,2.67,0,0,1-.59.4l1.09,3.61a1.25,1.25,0,0,0,1.74.8,18.93,18.93,0,0,1,2.28-.75,3.69,3.69,0,0,0,1.31-.69,3,3,0,0,0,.79-.89l3.46-6.62a2,2,0,0,1,2.1-1l3.69.83a1.24,1.24,0,0,1,.37.14Zm-10.4,64.07a1,1,0,0,1-.35-.56l-1.25-4.14a1.24,1.24,0,0,0-1.74-.8,16.28,16.28,0,0,1-2.27.75,2.76,2.76,0,0,0-.72.3l.16.53a1.06,1.06,0,0,0,.48.64h0Zm-7.08-60.72a.8.8,0,0,0-.4-.11,1.06,1.06,0,0,0-.68.26l-5.54,4.35a1.39,1.39,0,0,0-.21.21.77.77,0,0,0-.15.16,3.48,3.48,0,0,0-.48.87l-.07.22h0a2.6,2.6,0,0,0-.15.89l.33,5.26A4.11,4.11,0,0,1,92,57.84c-.91,1.09-1.76,2.23-2.56,3.4a2.81,2.81,0,0,1-1.22.94,1.81,1.81,0,0,1-.49.14.93.93,0,0,1-.23,0,1.15,1.15,0,0,1-.32,0l-3.55-.17H83.5a1.43,1.43,0,0,0-.29,0,1.1,1.1,0,0,0-.26.06h0a1.48,1.48,0,0,0-.29.12,2.51,2.51,0,0,0-.52.32,2.23,2.23,0,0,0-.57.73L78.2,71a1.42,1.42,0,0,0,.56,1.8L82.71,75a1.71,1.71,0,0,1,.09,1,36.3,36.3,0,0,0-.62,3.58A4.47,4.47,0,0,1,81,82.07l-.06.05-4.85,4.45a1.86,1.86,0,0,0-.23.26l0,0a1,1,0,0,0-.19.32A2.83,2.83,0,0,0,75.26,89l.93,5.35a1,1,0,0,0,.42.72l5.8,3.34a1,1,0,0,1-.4-.7l-.92-5.35a2.38,2.38,0,0,1,.06-1,2.81,2.81,0,0,1,.76-1.4l4.84-4.45.06,0A4.55,4.55,0,0,0,88,83a33,33,0,0,1,.62-3.57,1.79,1.79,0,0,0-1-2l-2.87-1.22a1.43,1.43,0,0,1-.75-1.9l3.34-7.49a2.1,2.1,0,0,1,.57-.73,2.25,2.25,0,0,1,1.48-.53l3.56.17a2.39,2.39,0,0,0,1-.2,2.81,2.81,0,0,0,1.22-.94c.8-1.17,1.66-2.31,2.56-3.4a4.11,4.11,0,0,0,.86-2.55l-.33-5.25a2.46,2.46,0,0,1,.14-.91A2.93,2.93,0,0,1,99.37,51l5.53-4.35a1,1,0,0,1,1.09-.15ZM91.87,99.05a2.43,2.43,0,0,0-.59-2.33,10.93,10.93,0,0,1-.94-1.17,1.44,1.44,0,0,0-2-.45l-2.8,1.84-2,5.5a1.21,1.21,0,0,0,.49,1.5h0l5.84,3.37a1.22,1.22,0,0,1-.49-1.51Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.75,85.48l-4.84,4.45a2.81,2.81,0,0,0-.76,1.4L75.34,88a2.92,2.92,0,0,1,.29-.78,1,1,0,0,1,.19-.32l0,0a1.86,1.86,0,0,1,.23-.26l4.85-4.45Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94,65.54a2.39,2.39,0,0,1-1,.2l-3.56-.17a2.25,2.25,0,0,0-1.48.53l-5.82-3.36a2.51,2.51,0,0,1,.52-.32,1.48,1.48,0,0,1,.29-.12h0a1.1,1.1,0,0,1,.26-.06,1.43,1.43,0,0,1,.29,0h.09l3.55.17a1.15,1.15,0,0,0,.32,0l.23,0a2.84,2.84,0,0,0,.47-.15h0Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130.89,52.08a1,1,0,0,0-1,.12L125,55.42a1.41,1.41,0,0,1-2-.44,9.21,9.21,0,0,0-1-1.17,2.44,2.44,0,0,1-.57-2.34l.46-1.25,2.1-1.38a1,1,0,0,1,1-.1h0Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M123.45,43.18a1.24,1.24,0,0,0-.37-.14l-3.69-.83a2,2,0,0,0-2.1,1l-3.46,6.62a3,3,0,0,1-.79.89l-5.82-3.37a3,3,0,0,0,.78-.88l3.47-6.62a2,2,0,0,1,2.1-1l3.69.83a1.18,1.18,0,0,1,.38.16h0Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106,46.54a1,1,0,0,0-1.09.15L99.37,51a2.93,2.93,0,0,0-.92,1.45l-5.82-3.35.07-.22a3.48,3.48,0,0,1,.48-.87.77.77,0,0,1,.15-.16,1.39,1.39,0,0,1,.21-.21l5.54-4.35a1.06,1.06,0,0,1,.68-.26.8.8,0,0,1,.4.11Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132.27,58.18l-.92-5.35a.88.88,0,0,0-1.46-.63L125,55.42a1.41,1.41,0,0,1-2-.44,11.08,11.08,0,0,0-1-1.17,2.42,2.42,0,0,1-.57-2.33l2.5-6.76a1.25,1.25,0,0,0-.92-1.68l-3.69-.82a2,2,0,0,0-2.09,1l-3.47,6.62a3.67,3.67,0,0,1-2.1,1.58,18.93,18.93,0,0,0-2.28.75,1.25,1.25,0,0,1-1.74-.8l-1.25-4.14a.92.92,0,0,0-1.56-.5L99.37,51a3.11,3.11,0,0,0-1.05,2.35l.33,5.26a4.17,4.17,0,0,1-.86,2.55c-.91,1.09-1.77,2.22-2.57,3.4A2.87,2.87,0,0,1,93,65.74l-3.56-.17a2.27,2.27,0,0,0-2,1.25L84,74.32a1.44,1.44,0,0,0,.75,1.9l2.87,1.22a1.79,1.79,0,0,1,1,2A33.15,33.15,0,0,0,88,83a4.48,4.48,0,0,1-1.2,2.43l-4.9,4.5a3,3,0,0,0-.82,2.42L82,97.7a.88.88,0,0,0,1.46.63l4.9-3.22a1.4,1.4,0,0,1,2,.44,11.08,11.08,0,0,0,1,1.17,2.42,2.42,0,0,1,.57,2.33l-2.5,6.76a1.24,1.24,0,0,0,.92,1.68l3.69.82a2,2,0,0,0,2.09-1l3.47-6.61a3.67,3.67,0,0,1,2.1-1.58,18.24,18.24,0,0,0,2.27-.75,1.26,1.26,0,0,1,1.75.8l1.25,4.14a.92.92,0,0,0,1.56.49L114,99.48A3.07,3.07,0,0,0,115,97.14l-.33-5.27a4.16,4.16,0,0,1,.86-2.54c.91-1.09,1.77-2.23,2.57-3.4a2.84,2.84,0,0,1,2.25-1.15L124,85a2.26,2.26,0,0,0,2-1.26l3.35-7.49a1.44,1.44,0,0,0-.75-1.9l-2.87-1.22a1.78,1.78,0,0,1-1-2,33.58,33.58,0,0,0,.62-3.58,4.45,4.45,0,0,1,1.2-2.43l4.9-4.51A2.94,2.94,0,0,0,132.27,58.18ZM108.64,86.67c-6,4.71-11.73,3.43-12.82-2.87s2.9-15.23,8.9-19.94,11.73-3.43,12.82,2.87S114.64,82,108.64,86.67Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M182.2,82.32v0a1.14,1.14,0,0,0-1.23.1l-2.53,1.67-.57,1.52a2.94,2.94,0,0,0,.69,2.82,12.56,12.56,0,0,1,1.16,1.42,1.74,1.74,0,0,0,2.38.53L188,86.5a1.14,1.14,0,0,1,1.2-.13Zm-9.11,21.74c-.83-4.8-3.88-7.19-7.85-6.87a12.31,12.31,0,0,1,.82,2.81c1.31,7.6-3.51,18.39-10.75,24.09a14.7,14.7,0,0,1-7.59,3.39c2.37,5.1,8.38,5.58,14.63.67C169.59,122.45,174.4,111.66,173.09,104.06Zm.13-32.5h0a1.39,1.39,0,0,0-.47-.18l-4.46-1a2.42,2.42,0,0,0-2.52,1.17l-4.2,8a3.59,3.59,0,0,1-.94,1.07h0a4.22,4.22,0,0,1-.71.48l1.31,4.36a1.52,1.52,0,0,0,2.1,1,20.46,20.46,0,0,1,2.75-.9,4.68,4.68,0,0,0,1.59-.83,3.54,3.54,0,0,0,1-1.08l4.19-8a2.43,2.43,0,0,1,2.52-1.17l4.47,1a1.5,1.5,0,0,1,.45.16ZM160.65,149a1.39,1.39,0,0,1-.42-.68l-1.51-5a1.51,1.51,0,0,0-2.1-1,21,21,0,0,1-2.75.91,3.5,3.5,0,0,0-.87.36l.2.64a1.25,1.25,0,0,0,.58.77v0ZM152.1,75.61a1,1,0,0,0-.49-.13,1.24,1.24,0,0,0-.82.32l-6.69,5.25a2.84,2.84,0,0,0-.26.24,1.63,1.63,0,0,0-.17.2,4.53,4.53,0,0,0-.59,1.06c0,.08-.06.17-.08.25h0a3.07,3.07,0,0,0-.17,1.08l.4,6.36a5.12,5.12,0,0,1-1.05,3.08c-1.1,1.31-2.12,2.69-3.1,4.11a3.24,3.24,0,0,1-1.47,1.13,3.49,3.49,0,0,1-.58.18,1.45,1.45,0,0,1-.29,0,1.2,1.2,0,0,1-.38,0l-4.29-.21H132a2.07,2.07,0,0,0-.35,0,1.83,1.83,0,0,0-.32.07h0l-.35.14a3.25,3.25,0,0,0-.62.39,2.52,2.52,0,0,0-.69.88l-4,9a1.72,1.72,0,0,0,.68,2.18L131,114.1a2.19,2.19,0,0,1,.11,1.24,39.74,39.74,0,0,0-.75,4.31,5.45,5.45,0,0,1-1.44,2.94l-.07.06L123,128a1.43,1.43,0,0,0-.28.32l0,.05a1.9,1.9,0,0,0-.23.39A3.45,3.45,0,0,0,122,131l1.12,6.46a1.32,1.32,0,0,0,.51.88l7,4a1.21,1.21,0,0,1-.49-.85L129.06,135a2.94,2.94,0,0,1,.07-1.24,3.49,3.49,0,0,1,.92-1.68l5.85-5.38.07-.06a5.54,5.54,0,0,0,1.45-2.94,39.74,39.74,0,0,1,.75-4.31A2.16,2.16,0,0,0,137,117l-3.48-1.48a1.72,1.72,0,0,1-.9-2.29l4-9a2.33,2.33,0,0,1,.69-.88,2.67,2.67,0,0,1,1.78-.64l4.3.21a2.78,2.78,0,0,0,1.24-.25,3.32,3.32,0,0,0,1.48-1.13c1-1.42,2-2.8,3.1-4.11a5,5,0,0,0,1-3.08l-.4-6.35a2.91,2.91,0,0,1,.16-1.1,3.6,3.6,0,0,1,1.11-1.74l6.68-5.25a1.15,1.15,0,0,1,1.33-.19Zm-10,67.5a3,3,0,0,0-.7-2.82,10.79,10.79,0,0,1-1.15-1.42,1.73,1.73,0,0,0-2.38-.53l-3.38,2.22L132,147.2a1.49,1.49,0,0,0,.59,1.82h0l7.06,4.07a1.48,1.48,0,0,1-.6-1.83Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M135.9,126.71l-5.85,5.38a3.49,3.49,0,0,0-.92,1.68l-7-4a4.23,4.23,0,0,1,.35-.94,1.9,1.9,0,0,1,.23-.39l0-.05A1.43,1.43,0,0,1,123,128l5.86-5.38Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M144.65,102.62a2.78,2.78,0,0,1-1.24.25l-4.3-.21a2.67,2.67,0,0,0-1.78.64l-7-4.06a3.25,3.25,0,0,1,.62-.39l.35-.14h0a1.83,1.83,0,0,1,.32-.07,2.07,2.07,0,0,1,.35,0h.11l4.29.21a1.2,1.2,0,0,0,.38,0l.29,0c.18,0,.37-.12.56-.19h0Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M189.22,86.37a1.11,1.11,0,0,0-1.2.14L182.1,90.4a1.72,1.72,0,0,1-2.38-.54,11.45,11.45,0,0,0-1.16-1.41,2.94,2.94,0,0,1-.69-2.82l.57-1.51L181,82.45a1.13,1.13,0,0,1,1.23-.12h0Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M180.24,75.61a1.5,1.5,0,0,0-.45-.16l-4.47-1a2.43,2.43,0,0,0-2.52,1.17l-4.19,8a3.54,3.54,0,0,1-1,1.08l-7-4.07a3.59,3.59,0,0,0,.94-1.07l4.2-8a2.42,2.42,0,0,1,2.52-1.17l4.46,1a1.39,1.39,0,0,1,.47.18h0Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M159.15,79.67a1.15,1.15,0,0,0-1.33.19l-6.68,5.25A3.6,3.6,0,0,0,150,86.85l-7-4c0-.08.06-.17.08-.25a4.53,4.53,0,0,1,.59-1.06,1.63,1.63,0,0,1,.17-.2,2.84,2.84,0,0,1,.26-.24l6.69-5.25a1.24,1.24,0,0,1,.82-.32,1,1,0,0,1,.49.13Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M190.89,93.73l-1.11-6.46a1.07,1.07,0,0,0-1.77-.76L182.1,90.4a1.72,1.72,0,0,1-2.38-.54,12.37,12.37,0,0,0-1.15-1.41,2.92,2.92,0,0,1-.69-2.82l3-8.16a1.49,1.49,0,0,0-1.1-2l-4.46-1a2.42,2.42,0,0,0-2.53,1.18l-4.19,8a4.44,4.44,0,0,1-2.54,1.9,21.43,21.43,0,0,0-2.74.91,1.53,1.53,0,0,1-2.11-1l-1.51-5a1.12,1.12,0,0,0-1.89-.6l-6.68,5.26A3.75,3.75,0,0,0,149.87,88l.4,6.35a5,5,0,0,1-1,3.08c-1.1,1.31-2.13,2.69-3.1,4.11a3.46,3.46,0,0,1-2.72,1.38l-4.3-.21a2.77,2.77,0,0,0-2.47,1.51l-4,9.06a1.73,1.73,0,0,0,.9,2.29L137,117a2.14,2.14,0,0,1,1.19,2.39,39.84,39.84,0,0,0-.74,4.32,5.36,5.36,0,0,1-1.45,2.94l-5.92,5.44a3.58,3.58,0,0,0-1,2.92l1.11,6.46a1.06,1.06,0,0,0,1.76.76l5.92-3.89a1.73,1.73,0,0,1,2.38.53,10.79,10.79,0,0,0,1.15,1.42,2.92,2.92,0,0,1,.69,2.82l-3,8.16a1.49,1.49,0,0,0,1.1,2l4.46,1a2.41,2.41,0,0,0,2.53-1.17l4.19-8a4.37,4.37,0,0,1,2.53-1.9,21,21,0,0,0,2.75-.91,1.52,1.52,0,0,1,2.11,1l1.51,5a1.11,1.11,0,0,0,1.88.59l6.69-5.25a3.75,3.75,0,0,0,1.27-2.84l-.4-6.36a5,5,0,0,1,1-3.07c1.09-1.31,2.13-2.69,3.1-4.11a3.45,3.45,0,0,1,2.72-1.38l4.3.21a2.77,2.77,0,0,0,2.47-1.51l4-9.06a1.72,1.72,0,0,0-.9-2.29L183,111.74a2.16,2.16,0,0,1-1.19-2.39,42.52,42.52,0,0,0,.75-4.32,5.42,5.42,0,0,1,1.44-2.94l5.93-5.44A3.59,3.59,0,0,0,190.89,93.73Zm-28.54,34.42c-7.25,5.69-14.18,4.14-15.49-3.47s3.5-18.39,10.74-24.09,14.18-4.14,15.49,3.47S169.59,122.45,162.35,128.15Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.49,215.43a2.84,2.84,0,0,0-.15-2.51A23.71,23.71,0,0,1,41,207.78a1.23,1.23,0,0,0-1.73-.8l-2.51,1.13a16.74,16.74,0,0,0,.83,1.51,2.86,2.86,0,0,1,.15,2.5l-6.9,13.93a1.58,1.58,0,0,0,.61,2l5.67,3.27a1.58,1.58,0,0,1-.56-2Zm30.68-96.94a.84.84,0,0,0-.37-.08,1.08,1.08,0,0,0-.57.16l-11.64,6.72-.17.12a2.2,2.2,0,0,0-.18.14l-.16.16a2.84,2.84,0,0,0-.3.37,2.79,2.79,0,0,0-.57,1.39L59,140.42a4.31,4.31,0,0,1-1.21,2.42,70.2,70.2,0,0,0-6.47,6.84,2.23,2.23,0,0,1-2.29.65l-7.46-2.61a1.34,1.34,0,0,0-.59-.08h0a.14.14,0,0,0-.09,0,.2.2,0,0,0-.11,0l-.22.05a1.77,1.77,0,0,0-.65.34.4.4,0,0,0-.12.1,1.17,1.17,0,0,0-.28.35l-8.57,14.82a1.76,1.76,0,0,0-.18,1.08,1.69,1.69,0,0,0,.56,1.13l6,5.17a2.21,2.21,0,0,1,.58,2.3,67.8,67.8,0,0,0-2.69,9,4.09,4.09,0,0,1-.66,1.37,1.33,1.33,0,0,1-.21.26l-.19.24a3.72,3.72,0,0,1-.44.38l-10.63,7.49-.19.15a1.8,1.8,0,0,0-.19.2,3.11,3.11,0,0,0-.81,1.93v13.44a1,1,0,0,0,.42.87L28,211.67a1,1,0,0,1-.42-.87V197.36a3.1,3.1,0,0,1,.47-1.5,2.77,2.77,0,0,1,.71-.8l10.64-7.47a3.91,3.91,0,0,0,.83-.88,4.28,4.28,0,0,0,.66-1.39,73.44,73.44,0,0,1,2.69-9A2.21,2.21,0,0,0,43,174l-6-5.17a1.7,1.7,0,0,1-.57-1.13,1.62,1.62,0,0,1,.19-1.08l8.56-14.82a1.81,1.81,0,0,1,1.42-.86,1.56,1.56,0,0,1,.68.08l7.47,2.61a2.21,2.21,0,0,0,2.29-.64,68,68,0,0,1,6.46-6.85,4.31,4.31,0,0,0,1.21-2.42l1.17-12.95a2.54,2.54,0,0,1,.21-.77,3.12,3.12,0,0,1,1.18-1.41L79,121.87a1,1,0,0,1,.88-.11ZM66.3,233.76a1,1,0,0,1-.39-.77l-1.13-11.3a1.23,1.23,0,0,0-1.56-1.09,23.7,23.7,0,0,1-3.89.53l.86,8.57a1,1,0,0,0,.44.78h0Zm18.23-81c1.67,2.31,2.55,5.83,2.55,10.43,0,12.54-8.8,27.79-19.67,34.06-4.23,2.45-7.84,3.26-10.67,2.6,3.52,4.09,9.55,4.65,16.4.7C84,194.23,92.8,179,92.8,166.44,92.8,158.8,89.54,153.94,84.53,152.71Zm11.32-36.12a1.56,1.56,0,0,0-2.06.48L85.18,130l-.12.16a1.39,1.39,0,0,1-.21.21l-.11.09-.12.1a2.92,2.92,0,0,1-1.69.56,16.31,16.31,0,0,0-1.71,0l.27,2.74A1.23,1.23,0,0,0,83.05,135a23.57,23.57,0,0,1,5.61-.56,2.92,2.92,0,0,0,1.68-.56,1.87,1.87,0,0,0,.56-.56l8.61-13a1.56,1.56,0,0,1,2-.48Zm16.66,24a.73.73,0,0,0-.19-.07,1.08,1.08,0,0,0-.71.09l-7.85,3.53c.2.37.37.74.54,1.13s.29.67.41,1a.6.6,0,0,1,.08.21c.15.36.27.71.39,1.09a1.72,1.72,0,0,1,.07.21,1.28,1.28,0,0,0,.31.53.53.53,0,0,0,.14.12l.1.07a.75.75,0,0,0,.3.14l.1,0a1.4,1.4,0,0,0,.5,0h0a1.19,1.19,0,0,0,.22-.08l10.36-4.67a1,1,0,0,1,.77-.07.35.35,0,0,1,.14.06Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.55,119.88a1.56,1.56,0,0,0-2,.48l-8.61,13a1.87,1.87,0,0,1-.56.56l-5.72-3.3h0l.24-.18a1.39,1.39,0,0,0,.21-.21l.12-.16,8.61-12.94a1.56,1.56,0,0,1,2.06-.48Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.27,186.71a3.91,3.91,0,0,1-.83.88L28.8,195.06a2.77,2.77,0,0,0-.71.8l-5.71-3.29a4,4,0,0,1,.32-.45,1.8,1.8,0,0,1,.19-.2l.19-.15,10.63-7.49a3.72,3.72,0,0,0,.44-.38l.19-.24c.07-.08.13-.17.2-.26h0Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.65,150.94a1.81,1.81,0,0,0-1.42.86l-8.56,14.82a1.62,1.62,0,0,0-.19,1.08l-5.72-3.3a1.76,1.76,0,0,1,.18-1.08l8.57-14.82a1.17,1.17,0,0,1,.28-.35.4.4,0,0,1,.12-.1,1.77,1.77,0,0,1,.65-.34l.22-.05a.2.2,0,0,1,.11,0,.14.14,0,0,1,.09,0h0Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.84,121.76a1,1,0,0,0-.88.11l-11.64,6.72A3.12,3.12,0,0,0,66.14,130l-5.71-3.3a3.42,3.42,0,0,1,.35-.62,2.84,2.84,0,0,1,.3-.37l.16-.16a2.2,2.2,0,0,1,.18-.14l.17-.12,11.64-6.72a1.08,1.08,0,0,1,.57-.16.84.84,0,0,1,.37.08Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112.51,140.62l5.73,3.31a.35.35,0,0,0-.14-.06,1,1,0,0,0-.77.07L107,148.61a1.19,1.19,0,0,1-1.41-.26,1.28,1.28,0,0,1-.31-.53,1.72,1.72,0,0,0-.07-.21c-.12-.38-.24-.73-.39-1.09a.6.6,0,0,0-.08-.21c-.12-.34-.26-.68-.41-1s-.34-.76-.54-1.13l7.85-3.53a1.08,1.08,0,0,1,.71-.09l.19.08Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 118.24,
    y: 143.93,
    width: 0.01,
    height: 0.01,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M118.65,158.24V144.79a.86.86,0,0,0-1.32-.85L107,148.61a1.24,1.24,0,0,1-1.73-.8,23.24,23.24,0,0,0-2.31-5.14,2.88,2.88,0,0,1-.15-2.51l6.9-13.92a1.56,1.56,0,0,0-.61-2l-7.49-4.33a1.58,1.58,0,0,0-2.07.49l-8.6,12.94a2.87,2.87,0,0,1-2.26,1.12,23,23,0,0,0-5.6.57,1.23,1.23,0,0,1-1.55-1.1l-1.14-11.31a.86.86,0,0,0-1.4-.71L67.32,128.6a3.11,3.11,0,0,0-1.39,2.17l-1.17,12.95a4.31,4.31,0,0,1-1.21,2.42A70.11,70.11,0,0,0,57.09,153a2.22,2.22,0,0,1-2.29.65L47.33,151a1.84,1.84,0,0,0-2.1.78l-8.56,14.82a1.83,1.83,0,0,0,.38,2.21L43,174a2.21,2.21,0,0,1,.58,2.3,70.11,70.11,0,0,0-2.69,9,4.3,4.3,0,0,1-1.49,2.26l-10.63,7.49a3.11,3.11,0,0,0-1.19,2.28V210.8a.86.86,0,0,0,1.32.85L39.3,207a1.23,1.23,0,0,1,1.73.8,23.24,23.24,0,0,0,2.31,5.14,2.88,2.88,0,0,1,.16,2.51l-6.91,13.92a1.57,1.57,0,0,0,.61,2l7.5,4.33a1.57,1.57,0,0,0,2.06-.49l8.61-12.94a2.85,2.85,0,0,1,2.25-1.12,23,23,0,0,0,5.6-.57,1.24,1.24,0,0,1,1.56,1.1L65.91,233a.87.87,0,0,0,1.41.71L79,227a3.17,3.17,0,0,0,1.39-2.17l1.16-12.95a4.31,4.31,0,0,1,1.21-2.42,70.2,70.2,0,0,0,6.47-6.84,2.21,2.21,0,0,1,2.28-.65L99,204.57a1.83,1.83,0,0,0,2.09-.78L109.6,189a1.82,1.82,0,0,0-.37-2.21l-6-5.17a2.21,2.21,0,0,1-.58-2.3,70.11,70.11,0,0,0,2.69-9,4.36,4.36,0,0,1,1.49-2.26l10.64-7.49A3.13,3.13,0,0,0,118.65,158.24ZM73.14,200.5c-10.86,6.27-19.67,1.19-19.67-11.35s8.81-27.79,19.67-34.06S92.8,153.9,92.8,166.44,84,194.23,73.14,200.5Z",
    style: {
      fill: "#f0f0f0"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Window--inject-217"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--window--inject-217"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M362.11,41.15l-274,158v202a3.5,3.5,0,0,0,5.24,3l4.89-2.82L357,252.15a11.31,11.31,0,0,0,5.11-8.85Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M361.14,42.83V243.3a10.4,10.4,0,0,1-4.63,8L97.71,400.53l-4.88,2.82a2.48,2.48,0,0,1-1.25.34,2.57,2.57,0,0,1-1.77-.72,2.47,2.47,0,0,1-.77-1.82V199.74L361.14,42.83m1-1.68-274,158v202a3.51,3.51,0,0,0,3.51,3.51,3.47,3.47,0,0,0,1.73-.47l4.89-2.82L357,252.15a11.31,11.31,0,0,0,5.11-8.85V41.15Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "355.61 37.4 81.55 195.42 88.07 199.18 362.11 41.15 355.61 37.4",
    style: {
      fill: "#455a64",
      opacity: 0.8
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.91,404.24a3.54,3.54,0,0,1-1.84-3.09v-202l-6.52-3.76V396.27a4.73,4.73,0,0,0,0,.75,5.39,5.39,0,0,0,2.66,4l5.38,3.11.27.15Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.55,195.51V181.88a5.68,5.68,0,0,1,2.55-4.43l269-155a5.6,5.6,0,0,1,5.09,0l1.4.81a5.64,5.64,0,0,1,2.55,4.42V41.26l-274,158Z",
    style: {
      fill: "#34C38F"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.55,195.51V181.88a5.68,5.68,0,0,1,2.55-4.43l269-155a5.6,5.6,0,0,1,5.09,0l1.4.81a5.64,5.64,0,0,1,2.55,4.42V41.26l-274,158Z",
    style: {
      fill: "#fff",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.07,185.64a5.69,5.69,0,0,1,2.54-4.43l269-155.06c1.4-.82,2.54-.17,2.54,1.46V41.26l-274,158Z",
    style: {
      fill: "#34C38F"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.81,183.12a5.25,5.25,0,0,0-.74,2.52v13.63l-6.51-3.76V181.88a5.19,5.19,0,0,1,.74-2.51Z",
    style: {
      fill: "#34C38F"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.81,183.12a5.25,5.25,0,0,0-.74,2.52v13.63l-6.51-3.76V181.88a5.19,5.19,0,0,1,.74-2.51Z",
    style: {
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M350.15,40.64c0,1.53,1.07,2.14,2.39,1.38a5.29,5.29,0,0,0,2.39-4.14c0-1.53-1.07-2.14-2.39-1.38A5.29,5.29,0,0,0,350.15,40.64Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M340.58,46.16c0,1.53,1.07,2.15,2.39,1.38a5.27,5.27,0,0,0,2.39-4.14c0-1.52-1.07-2.14-2.39-1.38A5.29,5.29,0,0,0,340.58,46.16Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M331,51.69c0,1.52,1.08,2.14,2.4,1.38a5.29,5.29,0,0,0,2.39-4.14c0-1.53-1.07-2.15-2.39-1.39A5.32,5.32,0,0,0,331,51.69Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M185.52,157v74.8a4.75,4.75,0,0,1-2.16,3.74L109.81,278.1a2.48,2.48,0,0,1-.37.17h0c-1,.4-1.78-.18-1.78-1.41V202a4.57,4.57,0,0,1,.63-2.12,4.29,4.29,0,0,1,1.53-1.6l73.56-42.58c1-.57,1.83-.27,2.08.63a1.28,1.28,0,0,1,.05.27C185.51,156.75,185.52,156.87,185.52,157Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M349.9,62.17v106a4.73,4.73,0,0,1-2.15,3.72L211,250.85a2.53,2.53,0,0,1-.37.18l-.05,0c-1,.35-1.75-.23-1.75-1.44v-106a4.44,4.44,0,0,1,.64-2.12,4.38,4.38,0,0,1,1.52-1.61l136.77-79c1-.57,1.83-.27,2.08.64a1.41,1.41,0,0,1,.05.27C349.89,61.94,349.9,62.05,349.9,62.17Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115.53,371.67a4.5,4.5,0,0,1-2.29-.6c-1.64-.94-2.54-2.9-2.54-5.51,0-5.16,3.64-11.46,8.11-14h0c2.26-1.31,4.41-1.5,6-.55s2.54,2.9,2.54,5.51c0,5.16-3.64,11.46-8.11,14A7.61,7.61,0,0,1,115.53,371.67Zm7-20.33a6.64,6.64,0,0,0-3.27,1h0a16.87,16.87,0,0,0-7.62,13.2c0,2.25.73,3.91,2.06,4.68s3.13.57,5.08-.55a16.9,16.9,0,0,0,7.62-13.21c0-2.25-.73-3.91-2.06-4.68A3.63,3.63,0,0,0,122.56,351.34Z",
    style: {
      fill: "#34C38F"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116.55,360.84a.36.36,0,0,1,0-.24.8.8,0,0,1,.09-.3l1.9-3.38c0-.08.09-.16.14-.24a.53.53,0,0,1,.16-.17l.68-.39a.14.14,0,0,1,.17,0,.34.34,0,0,1,.07.22V365a.82.82,0,0,1-.07.3.44.44,0,0,1-.17.2l-.71.41a.12.12,0,0,1-.16,0,.29.29,0,0,1-.07-.22v-6.62l-1.24,2.2a.35.35,0,0,1-.17.17.13.13,0,0,1-.16-.05Z",
    style: {
      fill: "#34C38F"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M139.14,358a4.6,4.6,0,0,1-2.3-.59c-1.64-.95-2.54-2.91-2.54-5.51,0-5.17,3.64-11.47,8.11-14.05h0c2.26-1.3,4.41-1.5,6.05-.55s2.54,2.91,2.54,5.51c0,5.16-3.64,11.47-8.11,14A7.58,7.58,0,0,1,139.14,358Zm7-20.32a6.72,6.72,0,0,0-3.27,1h0a16.89,16.89,0,0,0-7.62,13.21c0,2.24.73,3.9,2.06,4.67s3.14.57,5.08-.55A16.89,16.89,0,0,0,150,342.85c0-2.24-.73-3.9-2.06-4.67A3.53,3.53,0,0,0,146.16,337.72Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M143.15,346.58a2.78,2.78,0,0,0,.33-.85,3.46,3.46,0,0,0,.08-.66,1.21,1.21,0,0,0-.22-.81c-.14-.17-.38-.16-.72,0a1.59,1.59,0,0,0-.7.77,3.94,3.94,0,0,0-.32,1.1.8.8,0,0,1-.11.33.57.57,0,0,1-.15.18l-.69.39a.13.13,0,0,1-.17,0,.26.26,0,0,1-.07-.22,6.12,6.12,0,0,1,.2-1.26,6.75,6.75,0,0,1,.47-1.21,5.25,5.25,0,0,1,.68-1,3.29,3.29,0,0,1,.85-.72,1.55,1.55,0,0,1,.95-.28,1,1,0,0,1,.66.33,1.8,1.8,0,0,1,.39.74,3.87,3.87,0,0,1,.13,1c0,.23,0,.44,0,.66a4.53,4.53,0,0,1-.12.67,7.68,7.68,0,0,1-.28.79c-.12.29-.29.62-.49,1l-1.61,3.2,2.42-1.4a.12.12,0,0,1,.17,0,.31.31,0,0,1,.07.21v1a.82.82,0,0,1-.07.29.39.39,0,0,1-.17.2l-4.07,2.35a.11.11,0,0,1-.16,0,.25.25,0,0,1-.07-.21v-.82a1.19,1.19,0,0,1,.08-.45,3.51,3.51,0,0,1,.15-.32Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M162.74,344.41a4.44,4.44,0,0,1-2.29-.59c-1.65-.95-2.55-2.9-2.55-5.51,0-5.16,3.64-11.46,8.11-14h0c2.26-1.31,4.41-1.5,6.05-.56s2.54,2.91,2.54,5.52c0,5.16-3.63,11.46-8.11,14A7.58,7.58,0,0,1,162.74,344.41Zm7-20.32a6.72,6.72,0,0,0-3.27,1h0a16.9,16.9,0,0,0-7.62,13.21c0,2.25.73,3.91,2.06,4.67s3.13.58,5.08-.55a16.88,16.88,0,0,0,7.62-13.2c0-2.25-.73-3.91-2.06-4.68A3.53,3.53,0,0,0,169.76,324.09Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M168.18,328a.11.11,0,0,1,.16,0,.27.27,0,0,1,.07.21v1a.94.94,0,0,1-.06.31,2.73,2.73,0,0,1-.13.29l-1.27,2.8a1.71,1.71,0,0,1,.71-.11,1,1,0,0,1,.55.24,1.37,1.37,0,0,1,.34.61,3.1,3.1,0,0,1,.13,1,5,5,0,0,1-.18,1.34,5.4,5.4,0,0,1-.5,1.21,5,5,0,0,1-.75,1,4.26,4.26,0,0,1-.93.74,2.67,2.67,0,0,1-1.06.39,1.2,1.2,0,0,1-.75-.14,1.07,1.07,0,0,1-.46-.52,2,2,0,0,1-.18-.77.54.54,0,0,1,.06-.3.5.5,0,0,1,.17-.2l.69-.4c.06,0,.11,0,.14,0a.46.46,0,0,1,.12.18.83.83,0,0,0,.14.22.46.46,0,0,0,.23.12.77.77,0,0,0,.36,0,2.37,2.37,0,0,0,.54-.24,2.47,2.47,0,0,0,.85-.82,2.06,2.06,0,0,0,.33-1.12c0-.41-.11-.63-.33-.68a1.22,1.22,0,0,0-.85.24l-.73.41a.11.11,0,0,1-.16,0,.27.27,0,0,1-.07-.21v-1a.89.89,0,0,1,.06-.31,2.73,2.73,0,0,1,.13-.29l1.22-2.68-2.41,1.39a.13.13,0,0,1-.16,0,.29.29,0,0,1-.07-.22v-.95a.66.66,0,0,1,.07-.3.47.47,0,0,1,.16-.2Z",
    style: {
      fill: "#e0e0e0"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--character-2--inject-217"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--Character--inject-217"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--Arm--inject-217"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M413.63,121.89l-23.6.68c-.87-.75-5.49-5.36-5.49-5.36S371,115.47,370.88,116s12,15.17,13.33,16.63a8.27,8.27,0,0,0,4.6,2.27c3.51.21,22.81.4,22.81.4Z",
    style: {
      fill: "#b16668"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M414.8,121.89c-1.89-.52-24.34.35-24.34.35l-5.76-5.43s-3.27-.6-8.19-1.06-6.54,0-6.54,0,10.94,13.65,12.62,15.9,2.75,3.61,6.52,3.76c4.76.19,23.43.3,23.43.3Z",
    style: {
      fill: "#455a64"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Tab--inject-217"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M248.48,286.78l-.74-.43a4.78,4.78,0,0,1-2.16-3.74v-106a4.78,4.78,0,0,1,2.16-3.74L384.5,93.93a4.75,4.75,0,0,1,4.31,0l.75.43a4.75,4.75,0,0,1,2.15,3.73v106a4.75,4.75,0,0,1-2.15,3.73l-136.76,79A4.77,4.77,0,0,1,248.48,286.78Z",
    style: {
      fill: "#34C38F"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M391.69,97.75c-.14-1.12-1.05-1.53-2.13-.91l-136.77,79a4.34,4.34,0,0,0-1.52,1.6l-5.05-2.91a4.33,4.33,0,0,1,1.52-1.62L384.5,93.93a4.75,4.75,0,0,1,4.31,0l.75.43A4.82,4.82,0,0,1,391.69,97.75Z",
    style: {
      fill: "#fff",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M252.43,287a4.78,4.78,0,0,1-3.94-.17l-.76-.43a4.78,4.78,0,0,1-2.14-3.74v-106a4.23,4.23,0,0,1,.63-2.12l5.05,2.91a4.46,4.46,0,0,0-.63,2.12v106C250.64,286.77,251.41,287.34,252.43,287Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M264.59,263.85a.49.49,0,0,1-.42-.24.48.48,0,0,1,.18-.66l114.07-65.86a.48.48,0,0,1,.66.18.49.49,0,0,1-.18.66L264.83,263.79A.53.53,0,0,1,264.59,263.85Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M259.32,255.05l4.64-2.68c.35-.2.63,0,.63.37v.81a1.37,1.37,0,0,1-.63,1.09l-4.64,2.68c-.35.2-.63,0-.63-.36v-.82A1.39,1.39,0,0,1,259.32,255.05Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M259.32,243.7,264,241c.35-.2.63,0,.63.37v.82a1.39,1.39,0,0,1-.63,1.09L259.32,246c-.35.2-.63,0-.63-.36v-.82A1.39,1.39,0,0,1,259.32,243.7Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M259.32,232.35l4.64-2.68c.35-.2.63,0,.63.36v.82a1.39,1.39,0,0,1-.63,1.09l-4.64,2.68c-.35.2-.63,0-.63-.37v-.81A1.37,1.37,0,0,1,259.32,232.35Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M259.32,221l4.64-2.67c.35-.2.63,0,.63.36v.82a1.39,1.39,0,0,1-.63,1.09l-4.64,2.68c-.35.2-.63,0-.63-.37v-.82A1.39,1.39,0,0,1,259.32,221Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M259.32,209.64,264,207c.35-.21.63,0,.63.36v.82a1.39,1.39,0,0,1-.63,1.09l-4.64,2.67c-.35.2-.63,0-.63-.36v-.82A1.39,1.39,0,0,1,259.32,209.64Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M259.32,198.28,264,195.6c.35-.2.63,0,.63.36v.82a1.39,1.39,0,0,1-.63,1.09l-4.64,2.68c-.35.2-.63,0-.63-.36v-.82A1.39,1.39,0,0,1,259.32,198.28Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M259.32,186.93l4.64-2.68c.35-.2.63,0,.63.36v.82a1.39,1.39,0,0,1-.63,1.09l-4.64,2.68c-.35.2-.63,0-.63-.36V188A1.39,1.39,0,0,1,259.32,186.93Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M296.87,161.49,346.37,133c.45-.26.82,0,.82.48v1.06a1.82,1.82,0,0,1-.82,1.42l-49.5,28.53c-.45.26-.81.05-.81-.47V162.9A1.79,1.79,0,0,1,296.87,161.49Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M273.08,263l4.64-2.67c.35-.2.63,0,.63.36v.82a1.39,1.39,0,0,1-.63,1.09l-4.64,2.67c-.34.21-.63,0-.63-.36v-.82A1.41,1.41,0,0,1,273.08,263Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M286.86,255.05l4.63-2.67c.35-.2.63,0,.63.36v.82a1.39,1.39,0,0,1-.63,1.09l-4.63,2.68c-.35.2-.63,0-.63-.37v-.82A1.4,1.4,0,0,1,286.86,255.05Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M300.63,247.1l4.64-2.68c.34-.2.62,0,.62.36v.82a1.4,1.4,0,0,1-.62,1.09l-4.64,2.68c-.35.2-.63,0-.63-.36v-.82A1.39,1.39,0,0,1,300.63,247.1Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M314.4,239.14l4.64-2.67c.34-.2.63,0,.63.36v.82a1.41,1.41,0,0,1-.63,1.09l-4.64,2.68c-.35.2-.63,0-.63-.37v-.82A1.4,1.4,0,0,1,314.4,239.14Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M328.17,231.2l4.64-2.68c.35-.2.63,0,.63.36v.82a1.39,1.39,0,0,1-.63,1.09l-4.64,2.68c-.35.2-.63,0-.63-.37v-.81A1.37,1.37,0,0,1,328.17,231.2Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M341.94,223.25l4.64-2.68c.35-.2.63,0,.63.36v.82a1.39,1.39,0,0,1-.63,1.09l-4.64,2.68c-.34.2-.63,0-.63-.36v-.82A1.41,1.41,0,0,1,341.94,223.25Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M355.72,215.3l4.63-2.68c.35-.2.63,0,.63.36v.82a1.39,1.39,0,0,1-.63,1.09l-4.63,2.68c-.35.2-.63,0-.63-.37v-.82A1.37,1.37,0,0,1,355.72,215.3Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M369.49,207.34l4.64-2.67c.34-.2.62,0,.62.36v.82a1.4,1.4,0,0,1-.62,1.09l-4.64,2.67c-.35.2-.63,0-.63-.36v-.82A1.39,1.39,0,0,1,369.49,207.34Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M275.4,252.94a.36.36,0,0,1-.36-.36v-1.45a.36.36,0,0,1,.36-.36.37.37,0,0,1,.37.36v1.45A.37.37,0,0,1,275.4,252.94Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M275.4,248.46a.36.36,0,0,1-.36-.36v-3a.36.36,0,0,1,.36-.36.37.37,0,0,1,.37.36v3A.37.37,0,0,1,275.4,248.46Zm0-6.06A.37.37,0,0,1,275,242v-3a.36.36,0,0,1,.36-.36.37.37,0,0,1,.37.36v3A.38.38,0,0,1,275.4,242.4Zm0-6.07A.36.36,0,0,1,275,236v-3a.36.36,0,0,1,.36-.37.37.37,0,0,1,.37.37v3A.37.37,0,0,1,275.4,236.33Zm0-6.06a.37.37,0,0,1-.36-.37v-3a.36.36,0,0,1,.36-.36.37.37,0,0,1,.37.36v3A.38.38,0,0,1,275.4,230.27Zm0-6.07a.36.36,0,0,1-.36-.36v-3a.36.36,0,0,1,.36-.37.37.37,0,0,1,.37.37v3A.37.37,0,0,1,275.4,224.2Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M275.4,218.14a.37.37,0,0,1-.36-.37v-1.45a.36.36,0,0,1,.36-.36.37.37,0,0,1,.37.36v1.45A.38.38,0,0,1,275.4,218.14Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M289.17,245a.36.36,0,0,1-.36-.36v-1.45a.37.37,0,1,1,.73,0v1.45A.36.36,0,0,1,289.17,245Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M289.17,240.74a.36.36,0,0,1-.36-.36v-2.84a.37.37,0,0,1,.73,0v2.84A.36.36,0,0,1,289.17,240.74Zm0-5.67a.36.36,0,0,1-.36-.36v-2.84a.37.37,0,1,1,.73,0v2.84A.36.36,0,0,1,289.17,235.07Zm0-5.68a.36.36,0,0,1-.36-.36v-2.84a.37.37,0,0,1,.73,0V229A.36.36,0,0,1,289.17,229.39Zm0-5.67a.36.36,0,0,1-.36-.36v-2.84a.37.37,0,1,1,.73,0v2.84A.36.36,0,0,1,289.17,223.72Zm0-5.68a.36.36,0,0,1-.36-.36v-2.84a.37.37,0,0,1,.73,0v2.84A.36.36,0,0,1,289.17,218Zm0-5.67a.36.36,0,0,1-.36-.36v-2.84a.37.37,0,0,1,.73,0V212A.36.36,0,0,1,289.17,212.37Zm0-5.68a.36.36,0,0,1-.36-.36v-2.84a.37.37,0,0,1,.73,0v2.84A.36.36,0,0,1,289.17,206.69Zm0-5.67a.36.36,0,0,1-.36-.36v-2.84a.37.37,0,0,1,.73,0v2.84A.36.36,0,0,1,289.17,201Zm0-5.68a.36.36,0,0,1-.36-.36v-2.84a.37.37,0,0,1,.73,0V195A.36.36,0,0,1,289.17,195.34Zm0-5.67a.36.36,0,0,1-.36-.36v-2.84a.37.37,0,0,1,.73,0v2.84A.36.36,0,0,1,289.17,189.67Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M289.17,184a.37.37,0,0,1-.36-.37v-1.45a.37.37,0,0,1,.73,0v1.45A.37.37,0,0,1,289.17,184Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M303,237.12a.37.37,0,0,1-.37-.36v-1.45a.37.37,0,0,1,.37-.37.36.36,0,0,1,.36.37v1.45A.36.36,0,0,1,303,237.12Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M303,233a.38.38,0,0,1-.37-.37v-2.71a.38.38,0,0,1,.37-.37.37.37,0,0,1,.36.37v2.71A.37.37,0,0,1,303,233Zm0-5.43a.38.38,0,0,1-.37-.37v-2.71a.37.37,0,0,1,.37-.36.36.36,0,0,1,.36.36v2.71A.37.37,0,0,1,303,227.53Zm0-5.43a.37.37,0,0,1-.37-.36V219a.37.37,0,0,1,.37-.36.36.36,0,0,1,.36.36v2.72A.36.36,0,0,1,303,222.1Zm0-5.43a.37.37,0,0,1-.37-.36V213.6a.37.37,0,0,1,.37-.37.36.36,0,0,1,.36.37v2.71A.36.36,0,0,1,303,216.67Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M303,211.25a.38.38,0,0,1-.37-.37v-1.45a.37.37,0,0,1,.37-.36.36.36,0,0,1,.36.36v1.45A.37.37,0,0,1,303,211.25Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M316.72,229.21a.36.36,0,0,1-.36-.36v-1.46a.36.36,0,0,1,.72,0v1.46A.36.36,0,0,1,316.72,229.21Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M316.72,224.8a.37.37,0,0,1-.36-.37v-3a.36.36,0,0,1,.72,0v3A.37.37,0,0,1,316.72,224.8Zm0-5.93a.36.36,0,0,1-.36-.36v-3a.36.36,0,1,1,.72,0v3A.36.36,0,0,1,316.72,218.87Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M316.72,213a.36.36,0,0,1-.36-.36v-1.46a.36.36,0,0,1,.72,0v1.46A.36.36,0,0,1,316.72,213Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M330.49,221.3a.36.36,0,0,1-.36-.36v-1.46a.36.36,0,1,1,.72,0v1.46A.36.36,0,0,1,330.49,221.3Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M330.49,217a.36.36,0,0,1-.36-.36V213.8a.36.36,0,1,1,.72,0v2.84A.36.36,0,0,1,330.49,217Zm0-5.68a.37.37,0,0,1-.36-.37v-2.84a.36.36,0,0,1,.72,0V211A.37.37,0,0,1,330.49,211.32Zm0-5.69a.36.36,0,0,1-.36-.36v-2.85a.36.36,0,1,1,.72,0v2.85A.36.36,0,0,1,330.49,205.63Zm0-5.69a.36.36,0,0,1-.36-.36v-2.84a.36.36,0,0,1,.72,0v2.84A.36.36,0,0,1,330.49,199.94Zm0-5.68a.36.36,0,0,1-.36-.36v-2.85a.36.36,0,1,1,.72,0v2.85A.36.36,0,0,1,330.49,194.26Zm0-5.69a.36.36,0,0,1-.36-.36v-2.84a.36.36,0,1,1,.72,0v2.84A.36.36,0,0,1,330.49,188.57Zm0-5.68a.37.37,0,0,1-.36-.37v-2.84a.36.36,0,0,1,.72,0v2.84A.37.37,0,0,1,330.49,182.89Zm0-5.69a.36.36,0,0,1-.36-.36V174a.36.36,0,0,1,.72,0v2.85A.36.36,0,0,1,330.49,177.2Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M330.49,171.51a.36.36,0,0,1-.36-.36V169.7a.36.36,0,1,1,.72,0v1.45A.36.36,0,0,1,330.49,171.51Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M344.26,213.39a.37.37,0,0,1-.36-.37v-1.45a.36.36,0,0,1,.36-.36.37.37,0,0,1,.37.36V213A.38.38,0,0,1,344.26,213.39Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M344.26,208.9a.36.36,0,0,1-.36-.36v-3a.37.37,0,0,1,.36-.37.38.38,0,0,1,.37.37v3A.37.37,0,0,1,344.26,208.9Zm0-6.06a.36.36,0,0,1-.36-.37v-3a.36.36,0,0,1,.36-.36.37.37,0,0,1,.37.36v3A.37.37,0,0,1,344.26,202.84Zm0-6.07a.36.36,0,0,1-.36-.36v-3a.37.37,0,0,1,.36-.37.38.38,0,0,1,.37.37v3A.37.37,0,0,1,344.26,196.77Zm0-6.06a.36.36,0,0,1-.36-.36v-3a.36.36,0,0,1,.36-.36.37.37,0,0,1,.37.36v3A.37.37,0,0,1,344.26,190.71Zm0-6.07a.36.36,0,0,1-.36-.36v-3a.37.37,0,0,1,.36-.37.38.38,0,0,1,.37.37v3A.37.37,0,0,1,344.26,184.64Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M344.26,178.58a.36.36,0,0,1-.36-.36v-1.46a.36.36,0,0,1,.36-.36.37.37,0,0,1,.37.36v1.46A.37.37,0,0,1,344.26,178.58Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M358,205.48a.37.37,0,0,1-.36-.37v-1.45a.36.36,0,0,1,.36-.36.37.37,0,0,1,.37.36v1.45A.38.38,0,0,1,358,205.48Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M358,200.92a.36.36,0,0,1-.36-.36v-3.1a.36.36,0,0,1,.36-.36.37.37,0,0,1,.37.36v3.1A.37.37,0,0,1,358,200.92Zm0-6.2a.36.36,0,0,1-.36-.36v-3.1a.36.36,0,0,1,.36-.36.37.37,0,0,1,.37.36v3.1A.37.37,0,0,1,358,194.72Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M358,188.52a.36.36,0,0,1-.36-.36v-1.45a.37.37,0,0,1,.36-.37.38.38,0,0,1,.37.37v1.45A.37.37,0,0,1,358,188.52Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M371.81,197.56a.37.37,0,0,1-.37-.36v-1.45a.37.37,0,0,1,.37-.36.36.36,0,0,1,.36.36v1.45A.36.36,0,0,1,371.81,197.56Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M371.81,193.08a.37.37,0,0,1-.37-.36v-3a.37.37,0,0,1,.37-.36.36.36,0,0,1,.36.36v3A.36.36,0,0,1,371.81,193.08Zm0-6.06a.38.38,0,0,1-.37-.37v-3a.37.37,0,0,1,.37-.36.36.36,0,0,1,.36.36v3A.37.37,0,0,1,371.81,187Zm0-6.07a.37.37,0,0,1-.37-.36v-3a.37.37,0,0,1,.37-.36.36.36,0,0,1,.36.36v3A.36.36,0,0,1,371.81,181Zm0-6.06a.38.38,0,0,1-.37-.37v-3a.37.37,0,0,1,.37-.36.36.36,0,0,1,.36.36v3A.37.37,0,0,1,371.81,174.89Zm0-6.07a.37.37,0,0,1-.37-.36v-3a.37.37,0,0,1,.37-.37.36.36,0,0,1,.36.37v3A.36.36,0,0,1,371.81,168.82Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M371.81,162.76a.38.38,0,0,1-.37-.37v-1.45a.37.37,0,0,1,.37-.36.36.36,0,0,1,.36.36v1.45A.37.37,0,0,1,371.81,162.76Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M278.62,214.43c1.77-1.05,3.21-5.15,3.21-9.16V192.54a14,14,0,0,1,6.29-10.89l1.65-1c3.45-2,6.29-.36,6.29,3.63v21.81c0,4,2.83,5.63,6.28,3.63l3-1.75a2.64,2.64,0,0,1,4,2.29h0a2.64,2.64,0,0,0,3.93,2.31l3.14-1.75a14.19,14.19,0,0,0,6.23-11V177.79A13.72,13.72,0,0,1,329,167l1.56-.87c3.49-1.94,6.34-.27,6.34,3.73v3.64c0,4,2.83,5.63,6.29,3.63l1.66-1c3.46-2,6.29-.36,6.29,3.63v3.64c0,4,2.83,5.63,6.29,3.63l.78-.44a14,14,0,0,0,6.29-10.9v-3.64c0-4,1.64-8.21,3.66-9.38l3.67-2.11v36.33L275.4,252.58V216.32Z",
    style: {
      fill: "#fafafa",
      opacity: 0.6000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M275.4,216.81a.49.49,0,0,1-.24-.91l3.21-1.89c1.62-.95,3-4.95,3-8.74V192.54a14.45,14.45,0,0,1,6.53-11.31l1.64-.95c1.83-1.05,3.58-1.21,4.93-.43s2.09,2.37,2.09,4.48v21.81c0,1.75.57,3.05,1.61,3.65s2.44.44,4-.44l3-1.75a3.14,3.14,0,0,1,4.7,2.71,2.12,2.12,0,0,0,1.06,1.86,2.15,2.15,0,0,0,2.15,0l3.13-1.76a13.65,13.65,0,0,0,6-10.56V177.79a14.17,14.17,0,0,1,6.59-11.22l1.55-.87c1.84-1,3.61-1.16,5-.36s2.1,2.4,2.1,4.51v3.64c0,1.75.57,3,1.61,3.64s2.44.45,4-.43l1.66-1c1.83-1.06,3.58-1.21,4.93-.43s2.09,2.37,2.09,4.48v3.64c0,1.76.57,3,1.6,3.65s2.44.44,4-.43l.77-.45A13.39,13.39,0,0,0,364,175.72v-3.64c0-4.23,1.72-8.53,3.91-9.8l3.66-2.11a.49.49,0,0,1,.49.84l-3.67,2.11c-1.85,1.07-3.42,5.18-3.42,9v3.64A14.47,14.47,0,0,1,358.43,187l-.77.44c-1.83,1.06-3.58,1.21-4.93.44s-2.09-2.37-2.09-4.49v-3.64c0-1.75-.57-3-1.61-3.64s-2.44-.45-3.95.43l-1.67,1c-1.83,1.05-3.58,1.21-4.93.43s-2.09-2.37-2.09-4.48v-3.64c0-1.76-.57-3.06-1.62-3.68s-2.47-.48-4,.38l-1.55.86a13.14,13.14,0,0,0-6.09,10.38v22.09a14.76,14.76,0,0,1-6.47,11.4L313.51,213a3.12,3.12,0,0,1-4.65-2.73,2.16,2.16,0,0,0-3.24-1.87l-3,1.75c-1.83,1.06-3.58,1.21-4.93.44s-2.09-2.37-2.09-4.49V184.33c0-1.75-.57-3-1.6-3.64s-2.45-.45-4,.43l-1.64.95a13.36,13.36,0,0,0-6.05,10.47v12.73c0,4.23-1.52,8.43-3.46,9.57l-3.21,1.9A.55.55,0,0,1,275.4,216.81Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M289.17,178.21c1.09-.63,2-.12,2,1.13a4.36,4.36,0,0,1-2,3.41c-1.08.62-2,.12-2-1.14A4.34,4.34,0,0,1,289.17,178.21Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M344.26,173.73c1.09-.63,2-.12,2,1.13a4.34,4.34,0,0,1-2,3.41c-1.08.63-2,.12-2-1.14A4.34,4.34,0,0,1,344.26,173.73Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M303.35,206.43c1.09-.63,2-.12,2,1.14a4.32,4.32,0,0,1-2,3.4c-1.09.63-2,.12-2-1.13A4.34,4.34,0,0,1,303.35,206.43Z",
    style: {
      fill: "#37474f"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M366.39,103.73a37,37,0,0,1,4.4,1.17c2.2.78,3,2,3.62,4.08a8.12,8.12,0,0,1,.16,3.22,1.87,1.87,0,0,1-.44,1,4.32,4.32,0,0,1-1.26,1c-2,1.09-3.57,1.79-5.39.37-1.14-.88-2.19-1.88-3.39-2.67a10.88,10.88,0,0,0-3-1.23,15.36,15.36,0,0,0-3.77-.51,6.6,6.6,0,0,0-2.76,1,2.56,2.56,0,0,1,.56-3c1.69-1.54,4.34-3.8,6.34-4.42C363.2,103.19,364.57,103.48,366.39,103.73Z",
    style: {
      fill: "#b16668"
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "freepik--character--inject-217"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--Botom--inject-217"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M446.41,301.72c-2.52,1.45-5.36,1.42-8.44.25l-2-16.55,10,1Z",
    style: {
      fill: "#b16668"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M415.49,292.71c-2,4.74-6,3.56-10.45.7l.27-16.7,10.61-.32Z",
    style: {
      fill: "#b16668"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M428.19,318a3.8,3.8,0,0,0,.19,2.56c.34.51,2.31,2.09,5.77,2.23s6.26-.39,8.16-1.68a5.74,5.74,0,0,0,2.93-4.57c.13-1.89-.14-3.7.72-5.17s2.06-2.91,2.33-3.65a7.3,7.3,0,0,0-.09-3.83Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M436.77,301.27a9.76,9.76,0,0,1-.34,2.11,19.38,19.38,0,0,1-1.91,4.2,16.34,16.34,0,0,1-1.32,2c-1,1.22-2.17,2.23-3.2,3.4a6.84,6.84,0,0,0-1.92,4.12c-.06,2.6,2.78,3.4,5,3.72a16.09,16.09,0,0,0,7-.56,6.49,6.49,0,0,0,4.59-5.31c.09-.73,0-1.46.09-2.19a10.26,10.26,0,0,1,1.88-4.59,13.63,13.63,0,0,0,1.48-2.52c.62-1.62,0-3.41-.45-5-.42-1.37-.88-2.92-1.37-2.78a1.71,1.71,0,0,1-.09.84,3.45,3.45,0,0,0-.35.83,7.25,7.25,0,0,1-.37,1.08,2.81,2.81,0,0,1-1.11,1.3l-.18-2.93a1,1,0,0,0-1.09-1.2,18.6,18.6,0,0,0-5.56-.29.8.8,0,0,0-.84,1C436.75,299.45,436.81,300.36,436.77,301.27Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M434.19,308.14c.95-.76,3.11-.83,4.3-.74a7.22,7.22,0,0,1,3.39,1.08.78.78,0,0,0,1-.11h0a.72.72,0,0,0-.11-1.1,7.32,7.32,0,0,0-3.82-1.29c-2.92-.11-3.76.41-3.76.41S433.88,307.28,434.19,308.14Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M432.05,310.86c1.19-.76,3.58-.72,4.76-.63a6.62,6.62,0,0,1,3.31,1.15.78.78,0,0,0,1-.11h0a.72.72,0,0,0-.11-1.1,7.57,7.57,0,0,0-3.91-1.4c-2.92-.12-3.66.5-3.66.5A2.41,2.41,0,0,0,432.05,310.86Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M440,303.16a7.39,7.39,0,0,0-3.66.42c-.5.3-.81,1.12-.48,1.32a6.73,6.73,0,0,1,3.23-.54,9.47,9.47,0,0,1,3.18.77c.25.1.55.25.81.38a.7.7,0,0,0,.95-.32h0a.65.65,0,0,0-.28-.83A9.34,9.34,0,0,0,440,303.16Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M388,304.21a3.17,3.17,0,0,0,.2,2.3c.34.67,3.93,2.55,8.68,2.09a19.86,19.86,0,0,0,9.73-3.73c1.78-1.26,3.66-1.54,6-1.74s5.41-1.48,5.9-2.59a5.25,5.25,0,0,0-.17-3Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M406.66,289l-1.25-.42a1.1,1.1,0,0,0-.71-.06c-.3.12-.41.49-.48.8a12,12,0,0,1-.46,2.09,5.2,5.2,0,0,1-1.29,1.44,22.68,22.68,0,0,1-3.73,2.57c-1.53.88-3,1.57-4.62,2.34s-3.77,1.3-5,2.2a3.43,3.43,0,0,0,.19,5.67c1.86,1,6.73,2.05,11.75.46,2.73-.86,5.71-3.9,9.32-4.29,2.3-.25,6.63-1,8.06-2.82.53-.79-.28-3.23-.94-5.33-.73-2.3-1.08-5.91-1.84-5.69,0,.77-.69,1.24-1.07,1.9a13.79,13.79,0,0,0-.78,1.86,3.34,3.34,0,0,1-1.15,1.62,1.53,1.53,0,0,1-1.87-.05c-.7-.68-.33-1.92-.85-2.74a2.93,2.93,0,0,0-1.66-1Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M400.85,294.11a2.13,2.13,0,0,1,1.66-1.19,6.2,6.2,0,0,1,4.1,1.41.86.86,0,0,1-.08,1.42h0a.88.88,0,0,1-1-.08A6.56,6.56,0,0,0,400.85,294.11Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M397.66,296a2.45,2.45,0,0,1,2-1.1,7.63,7.63,0,0,1,4.48,1.52.85.85,0,0,1-.08,1.38h0a.83.83,0,0,1-1-.08A6.54,6.54,0,0,0,397.66,296Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M394.12,297.77a2.74,2.74,0,0,1,2.06-1,7.38,7.38,0,0,1,4.3,1.55.84.84,0,0,1-.08,1.37h0a.81.81,0,0,1-.95-.08A6.29,6.29,0,0,0,394.12,297.77Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M442.51,177.72c1.14,18.14,3,61.07,3,61.07.26,2.26,1.09,7.68,1.5,15.81.6,11.79-.34,37.83-.34,37.83a12.73,12.73,0,0,1-10.06.79s-6.71-37.13-8.86-48.71c-1.88-10.17-5.56-32.24-5.56-32.24L420.45,240a81.21,81.21,0,0,1-.4,15c-.67,5.38-3.91,28.73-3.91,28.73a21.41,21.41,0,0,1-11.39.09s-1-38.11-1.28-43.07c-.28-5.65-1.46-66.62-1.46-66.62Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M422.17,212.27,419,197.47s-7.46-.43-11.7-4.46c0,0,.85,4,10.29,6.21l3.13,15,.31,13.92Z",
    style: {
      fill: "#263238"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M439.08,123.73c3.57.63,3.81,2.4,4.59,5.94a29,29,0,0,1,.9,8.69l-2.65,20.91.91,24.08c-5.74,6.24-28.69,8.25-41.22-.91,0,0,.14-39.56.72-45.9,1-11.1,6-15,13.42-15l12.62,1.07Z",
    style: {
      fill: "#34C38F"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M425.74,95.69a11.21,11.21,0,1,1-11.17-11.24A11.2,11.2,0,0,1,425.74,95.69Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M429.25,97.88l2.39-6.42a4.21,4.21,0,0,1,3.48,1.23c1.49,1.54.64,6.32-1.24,11,0,0-1.84,8.53-2.58,9.93a3.89,3.89,0,0,1-2.24,1.79Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M429.43,104.07c.69.41,1.67-.9,2.52-1.78s3.61-2.09,5,.82-1.24,6.86-3.41,7.54c-3.76,1.16-4.31-1.24-4.31-1.24l-.33,13.51a12.08,12.08,0,0,1-9.12,6.87c-6.65.88-5.26-4.59-3.07-7.27l0-4.11a23.74,23.74,0,0,1-5,.24c-2.75-.44-4.48-2.62-5.3-5.6-1.33-4.8-1.83-8.67-.65-18.08C407,84.64,419,84.58,425.47,88.68S429.43,104.07,429.43,104.07Z",
    style: {
      fill: "#b16668"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M429.36,105c1.09-.32,1.88-2,2.59-2.69,1.19-1.08-.31-10.83-.31-10.83a4.62,4.62,0,0,0-1.12-4.94c-1.62-1.79-4.32-2-8.95-2.74-2.28-.36-5-.54-7.23-1a22.85,22.85,0,0,1-6.72-2.15,2.06,2.06,0,0,0-1.28-.33,1.21,1.21,0,0,0-.81.67,2.29,2.29,0,0,0-.19,1.07,4,4,0,0,0,.2,1.13c.07.21.51.87.42,1.06-.24.47-2-.32-2.37-.43a.29.29,0,0,0-.41.15,4.33,4.33,0,0,0,.21,3.75,12.63,12.63,0,0,0,6.36,5.41,17.42,17.42,0,0,0,8.68,1.21,16.3,16.3,0,0,0,3.7-.86,9.38,9.38,0,0,0,.81,1.27,5.46,5.46,0,0,0,1.2,1,4.74,4.74,0,0,0,1.44.67c.52.14,1,.07,1.32.64a2.68,2.68,0,0,1,.22,1.19l.1,3.59a5.7,5.7,0,0,0,.25,1.79,1.93,1.93,0,0,0,1.2,1.27A1.16,1.16,0,0,0,429.36,105Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M416.71,118.41s6.16-1.22,8.31-2.36a7,7,0,0,0,3-2.93,9.72,9.72,0,0,1-1.7,3.47c-1.58,2-9.6,3.45-9.6,3.45Z",
    style: {
      fill: "#9a4a4d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M417.62,102.21a1.24,1.24,0,1,0,1.24-1.28A1.27,1.27,0,0,0,417.62,102.21Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M419.1,98.41l2.73,1.77a1.72,1.72,0,0,0-.5-2.31A1.58,1.58,0,0,0,419.1,98.41Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M419.68,109.7l-4.34,1.86a2.4,2.4,0,0,0,3.19,1.26A2.3,2.3,0,0,0,419.68,109.7Z",
    style: {
      fill: "#9a4a4d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M406.32,99.75l2.6-1.57a1.45,1.45,0,0,0-2-.55A1.59,1.59,0,0,0,406.32,99.75Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M407.34,101.82a1.23,1.23,0,1,0,2.46,0,1.24,1.24,0,0,0-1.22-1.28A1.26,1.26,0,0,0,407.34,101.82Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "414.21 101.16 413.16 109.03 409.14 107.3 414.21 101.16",
    style: {
      fill: "#9a4a4d"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M439.52,123.82,424.61,156s-20.88-.66-27.74-1.92c-2.34-.42-1.93-1.72-2.88-4.22s-2.3-2-2.3-2l0,3.41c.08,2.25-3.5,3.4-5.09,4-2.61,1-5.48,1.67-8.18,2.51a4,4,0,0,0-2.4,1.46,2.55,2.55,0,0,0,.08,2.48c1.23,2.2,2.89,4.07,5.33,4.36,3,.36,6.37-.47,9.3-1,3.46-.62,5.9-1.43,9.33-1s8.11,1,11.38,1.58c3.77.68,11.87,2,15.15,2.11,2.37.1,4,1.07,6.66-3.25,1.85-3,6-10.87,9.6-17.81,3.66-7.15,4.88-11.64,4.69-16.17C447.46,128.27,445.52,124.3,439.52,123.82Z",
    style: {
      fill: "#b16668"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M438.45,123.66c3.07.18,5.76.62,7.57,2.15s3.42,4.11.84,13.16-13,25.85-14.52,27.93-3.79,1.53-8.19,1.06-13.71-2.45-13.71-2.45,1.43-7,.81-10.1l13,.28,8.19-20.32S435.15,127.35,438.45,123.66Z",
    style: {
      fill: "#455a64"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--character-1--inject-217"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--character--inject-217"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M196.14,434.4l-.43-11.62,9.35-5.61s-1,12.22-.77,13.9,2.37,2.72,2.76,3.85-5.36,13.08-8.74,15.78-9.1-.44-9.69-1.66,2.77-1.25,4.44-2.3c.59-.38,1.27-.89,1.27-.89A105.8,105.8,0,0,0,196.14,434.4Z",
    style: {
      fill: "#ffa8a7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M205.52,432.82c-1.09,1-1.87,3.35-3.3,6.61s-2.35,6.78-6.16,8.78c-2.58,1.36-6.35.36-4.47-.47a10.77,10.77,0,0,0,2.74-1.89,10.65,10.65,0,0,1-4.43,1.62c-2.12.28-6.5,1.58-3.66,4.8,1.1,1.24,3.42,1.94,8,2,4.36,0,6.36-1.32,7.9-4.49,1.87-3.83,6-7.86,7.31-10C211.08,437.1,208.2,433.42,205.52,432.82Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M262.29,403.51l-7-7.47,5.39-6.74,6.17,6.22c1.66,1.26,3.18.8,4.21,1.42s4.22,13.48,3.35,17.72-7.28,5.48-8.52,4.91,1.34-2.73,1.95-4.6c.21-.67.41-1.5.41-1.5A103.92,103.92,0,0,0,262.29,403.51Z",
    style: {
      fill: "#ffa8a7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M268.5,396.3c-.22,1.45.7,3.77,1.68,7.19s2.52,6.73.87,10.7c-1.12,2.69-4.65,4.33-3.74,2.49a10.89,10.89,0,0,0,.9-3.21,10.58,10.58,0,0,1-2.38,4.08c-1.44,1.57-4.09,5.62.2,5.7a12.08,12.08,0,0,0,7.83-2.55,9.39,9.39,0,0,0,2.86-9.21c-1-4.15-.44-9.86-.79-12.39C275.52,396,270.94,395.05,268.5,396.3Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M194.25,314.62s19.14,45.6,21.21,50.69,3.78,7.14,6.83,9.25S257.94,399,257.94,399c6.08-2.53,6.21-6.48,6.21-6.48s-16.07-20.4-20.35-24.16-11.12-6-11.12-6l-4.57-33.09c-1.34-6.51-.51-13.69-10.19-24.77h0Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M217.92,304.52l-32.8,3.78s.3,26.2,1.9,47.34c1.76,23.37,8.5,70.44,8.5,70.44a18.3,18.3,0,0,0,9.24-1S209,391,209,386.07a48.84,48.84,0,0,0-2.39-14.33c.64-10.24,4.43-24.1,5-36,8.63-3.56,11.78-8.36,13-14.79C225.78,314.77,220.24,308.3,217.92,304.52Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M209.65,351.36l2.82-17.56s8.88-3.17,12.3-7.78c0,0-1.09,6.7-9.47,9.89-.54.68-4.77,17.56-4.77,17.56Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M205.38,216.46c-3.71-3-5.66-4.77-8.63-7.48a1.91,1.91,0,0,0-3,.23l5.92,15.8a9.84,9.84,0,0,1,2.68,2.29c1.13,1.49,5,24.06,5,24.06l10.85-2.89S210.48,220.51,205.38,216.46Z",
    style: {
      fill: "#ffa8a7"
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "freepik--tab--inject-217"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M119.68,290.67l-.74-.43a4.78,4.78,0,0,1-2.16-3.73V211.7a4.79,4.79,0,0,1,2.16-3.74l73.56-42.57a4.81,4.81,0,0,1,4.31,0l.75.43a4.77,4.77,0,0,1,2.15,3.74v74.81a4.75,4.75,0,0,1-2.16,3.73L124,290.67A4.77,4.77,0,0,1,119.68,290.67Z",
    style: {
      fill: "#34C38F"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M199.69,169.21c-.15-1.11-1.05-1.52-2.13-.9L124,210.89a4.42,4.42,0,0,0-1.52,1.6l-5-2.91a4.33,4.33,0,0,1,1.52-1.62l73.55-42.56a4.77,4.77,0,0,1,4.32,0l.75.42A4.84,4.84,0,0,1,199.69,169.21Z",
    style: {
      fill: "#fff",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M123.63,290.84a4.78,4.78,0,0,1-3.94-.17l-.76-.43a4.77,4.77,0,0,1-2.15-3.74V211.7a4.27,4.27,0,0,1,.64-2.12l5,2.91a4.48,4.48,0,0,0-.64,2.13v74.81C121.83,290.66,122.61,291.24,123.63,290.84Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M149.12,219.26c-7.16,8.62-12.06,20.67-12.06,31.26a22.47,22.47,0,0,0,2.77,11.67l19.25-24.4Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M169,207.71a18.35,18.35,0,0,0-9.94,2.83,37.33,37.33,0,0,0-10,8.72l10,18.53Z",
    style: {
      fill: "#34C38F"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M169,207.71a18.35,18.35,0,0,0-9.94,2.83,37.33,37.33,0,0,0-10,8.72l10,18.53Z",
    style: {
      opacity: 0.45
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M179.06,214.75c-2.09-4.35-5.64-6.83-10-7l-9.94,30.08Z",
    style: {
      fill: "#34C38F"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M179.06,214.75l-20,23-19.25,24.4c3.78,6.14,11,7.63,19.25,2.85,12.16-7,22-24.92,22-40A23.84,23.84,0,0,0,179.06,214.75Z",
    style: {
      fill: "#34C38F"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M179.06,214.75c-2.09-4.35-5.64-6.83-10-7l-9.94,30.08Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M179.06,214.75l-20,23-19.25,24.4c3.78,6.14,11,7.63,19.25,2.85,12.16-7,22-24.92,22-40A23.84,23.84,0,0,0,179.06,214.75Z",
    style: {
      fill: "#34C38F"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M179.06,214.75l-20,23-19.25,24.4c3.78,6.14,11,7.63,19.25,2.85,12.16-7,22-24.92,22-40A23.84,23.84,0,0,0,179.06,214.75Z",
    style: {
      opacity: 0.25
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M139.83,262.7h0a.5.5,0,0,1-.4-.25,23,23,0,0,1-2.85-11.93c0-10.43,4.66-22.54,12.18-31.59a.51.51,0,0,1,.84.08l10,18.54a.5.5,0,0,1,0,.55l-19.25,24.4A.48.48,0,0,1,139.83,262.7Zm9.2-42.53c-7.09,8.81-11.46,20.37-11.46,30.35a22.83,22.83,0,0,0,2.33,10.76l18.57-23.54Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M159.08,238.3a.5.5,0,0,1-.45-.27l-10-18.53a.51.51,0,0,1,.05-.57,37.88,37.88,0,0,1,10.1-8.83A19,19,0,0,1,169,207.2a.54.54,0,0,1,.4.22.51.51,0,0,1,.06.45L159.56,238a.52.52,0,0,1-.44.35Zm-9.35-19L159,236.5l9.35-28.29a18.52,18.52,0,0,0-9,2.77A36.29,36.29,0,0,0,149.73,219.32Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M159.08,238.3a.48.48,0,0,1-.26-.07.51.51,0,0,1-.23-.6l9.94-30.08a.53.53,0,0,1,.51-.35c4.59.22,8.31,2.82,10.48,7.33a.49.49,0,0,1-.08.55l-20,23A.49.49,0,0,1,159.08,238.3Zm10.3-30.06-9,27.29,18.09-20.86A11,11,0,0,0,169.38,208.24Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M149.75,268.38a11.76,11.76,0,0,1-10.35-5.92.53.53,0,0,1,0-.59l19.24-24.4,20-23.05a.5.5,0,0,1,.46-.17.52.52,0,0,1,.39.28,24.27,24.27,0,0,1,2.1,10.52c0,15.2-10,33.33-22.29,40.43A19.42,19.42,0,0,1,149.75,268.38Zm-9.29-6.16c3.8,5.83,10.8,6.75,18.36,2.38,12-6.94,21.78-24.68,21.78-39.55a23.82,23.82,0,0,0-1.68-9.36l-19.46,22.43Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M145.61,206.15l26.95-15.54c.45-.27.81-.05.81.47v1.06a1.81,1.81,0,0,1-.81,1.42L145.61,209.1c-.45.26-.82.05-.82-.47v-1.06A1.82,1.82,0,0,1,145.61,206.15Z",
    style: {
      fill: "#455a64"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M155.25,291.28c-7,2-8.77.92-11.2-1.75-1.18-1.29-16.75-20.95-18.65-23.11s-2.11-2.72-5-4.06-3.72-1.55-5.09-3.22-.78-2.45-.85-3.52c-.09-1.48-.94-2.21-1-3.32-.12-1.38.51-2,.48-2.64,0-1-.59-1.33-.65-3.15,0-.63,2.57-3.28,3.48-4.28v4.89c2.86,4,7.49,3.67,8,3.1s.41-3.49,1.34-5.15,2.89-2.27,2.72-.64c-.08.95.17,4.24.22,5.72a12,12,0,0,0,1.31,5.66c1.49,2.64,23.78,23.67,23.78,23.67",
    style: {
      fill: "#ffa8a7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M199.68,219.56a8.37,8.37,0,0,0-2.74-2.46c-1.74-.95-2.55-2.45-2.12-3.43.33-.74,1.54,0,2.62.4s4.06,1.34,5.54,2.67,1.91,2.35,3.45,2.21a4.57,4.57,0,0,1-3.18,1.47A6,6,0,0,1,199.68,219.56Z",
    style: {
      fill: "#ffa8a7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M138.86,282.76c10.61-4.57,21.44-8.19,32.19-12.45,5-2,8.16-3.23,12-4.36,3.66-1.07,7.35-.93,11-1.58.44-.1.91-.18,1.39-.26,6.21-1.14,15.58-2.87,18.12-3.32.24-.05.46-.08.66-.13a7.18,7.18,0,0,1,1.79.06,6.22,6.22,0,0,1,3.83,3.27c1,2.26,1.37,4.25.63,8.1-.2,1-1.68,4.08-2.62,7.47-1.73,6.23-3.33,14.13-4.44,17.1-.07.13-.1.24-.15.33l4.64,7.54s-3.11,3.84-12.34,6.53-20.46-2.77-20.46-2.77-2.37-12.43-2.81-15.92c0-.2-.08-.51-.13-.87-.09-.74-.88-5.87-.88-5.87-.34-1-2.85-.68-10.58,1.59s-18,4.66-18,4.66Z",
    style: {
      fill: "#ffa8a7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M219.67,254.15c-2.95-11.51-5.75-23-5.75-23L202.37,235l8.51,36.27,9.62.87C222.58,264.84,221.28,260.42,219.67,254.15Z",
    style: {
      fill: "#ffa8a7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M207.42,261.66c.67-.1.69-.8.27-3s-1.05-4.92-1.05-4.92,7.76-3.29,12.88-2.16c0,0,.85,3.12,2.06,9.46s-.13,9.57-3.89,19.21Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "192 257.05 193.35 268.96 205.09 270.31 203.39 254.52 192 257.05",
    style: {
      fill: "#ffa8a7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M185,238.44a4.5,4.5,0,0,1-2.27-3.44,4.84,4.84,0,0,1,1.66-3.83,5.49,5.49,0,0,1-1.54-4.52,5,5,0,0,1,2.8-3.82,4.5,4.5,0,0,1,4.66.64,3.88,3.88,0,0,1,2-3.74,6.09,6.09,0,0,1,4.34-.55,14.44,14.44,0,0,1,4.1,1.76,38.72,38.72,0,0,0,3.69,2c1.2.52,2.76.88,4,1.31,4.48,1.55,10.89,5.75,9.56,17.21-.79,6.73-19.22,10.42-19.12,15.07l-.08-.09-5-6-3.82-4.59c-1.19-1.43-2.57-3-2.66-4.94a1.84,1.84,0,0,0-1.74-2.23A4.37,4.37,0,0,1,185,238.44Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M183.86,241.9s-2.85,3.91-2.52,4.35a6.41,6.41,0,0,0,2,1Z",
    style: {
      fill: "#f28f8f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M192.57,229.48c-2.65,1.22-7.24,3.5-8.82,13-1.61,9.75,0,13,1.24,14.31.86.91,5.72,1.13,8.18.48,3.09-.81,10.05-3.18,13.36-8.1,3.9-5.8,5-13.7.94-17C201.77,227.54,194.81,228.44,192.57,229.48Z",
    style: {
      fill: "#ffa8a7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M191.38,228.9c-.54.22-1.7.12-2.14.5a4.94,4.94,0,0,0-1.44,4.12,4.24,4.24,0,0,0,2.74,3.47,12.56,12.56,0,0,0-.19,3.88c.21,1.3.46,3,1.24,3.6,0,0,1.74-3.42,4.69-2.28s2.53,5.15.06,7.1-3.83.36-3.83.36-.26,4.87,3.43,6.9a10.5,10.5,0,0,0,7.88,2c2.61-3.6,6.09-5,9-7.83,7.59-7.44,7.07-18.45-3.46-22.48a20.54,20.54,0,0,0-9.62-1.33,18.77,18.77,0,0,0-3.57.77c-.49.16-1,.34-1.43.53a5.07,5.07,0,0,1-1.69.27A6.26,6.26,0,0,0,191.38,228.9Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M185,256.79c.75.79,4.47,1.06,7.06.7l-.18-1.75a20.51,20.51,0,0,1-3.93,1c-2.29.38-3.06-.1-3.1-.13Z",
    style: {
      fill: "#f28f8f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M217.53,283.33c-1.67,6.17-3,10.51-4.09,13.33-.07.13-.1.24-.15.33l4.64,7.54s-3.11,3.84-12.34,6.53S185.15,310,185.15,310s-4-23.91-4.05-24.33c11.82-5.28,9.27-20.92,9.27-20.92.84-.14,4.85-.68,5.34-.77,5.42-1,8.12-1.84,13.07-2.5C212.86,260.92,220.24,273.28,217.53,283.33Z",
    style: {
      fill: "#34C38F"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M214.39,293.8c-.11.27-9.13,5.42-11.86,6.17a22.64,22.64,0,0,0,10.77-3Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M190.37,264.73a25.82,25.82,0,0,0-7.79,1.16c-3.86,1.06-15,5.79-15,5.79s-1.55,10.67,3.18,15.54c0,0,4.84-1.12,7.33-1.59,2.12-.4,2.58-.7,3,0a11.88,11.88,0,0,0,7.75-6.33C191.75,273.82,191.39,266.78,190.37,264.73Z",
    style: {
      fill: "#455a64"
    }
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSetupAnalyticsAmico);
export default __webpack_public_path__ + "static/media/setup-analytics-amico.cf26efb0c639d5927ad5cdb55645b479.svg";
export { ForwardRef as ReactComponent };